<template>
    <tr>
        <td class="t_center">
            <span class="initial_name" v-if="item.deal.member_id" v-pml-tooltip.top-right="item.deal.member.full_name">{{ item.deal.member.name_initials }}</span>
        </td>
        <td class="t_center"><label class="label label-inverse">{{ item.number }}</label></td>
        <td>
            <router-link :to="{ name: 'deals.show', params: { id: item.deal_id } }">
                <span class="show bold">
                    {{ item.deal.lead.full_name }}
                    <label class="label label-sm pull-right" :class="getStatusLabelDeal(item.deal.status)" v-pml-tooltip="$t('status')">{{ $t(item.deal.status) }}</label>
                </span>
            </router-link>
            <small class="show t_overflow">{{ item.deal.lead.email }}</small>
        </td>
        <td class="t_center">{{ item.issue_date_at | pmlDate('DD/MM/YYYY') }}</td>
        <td class="t_center">
            <i class="fa fa-exclamation-triangle text-warning" v-if="isExpired(item)"></i>
            {{ item.due_date_at | pmlDate('DD/MM/YYYY') }}
        </td>
        <td class="t_right">
            <p class="m-0" v-if="tenant.currency_id !== item.currency_id">
                <small :class="getExchangeClass()" class="pull-left" v-pml-tooltip="$t('compared_to_today')">
                    <i class="fa" :class="{ 'fa-arrow-up': diffExchangeRate > 1, 'fa-arrows-h': diffExchangeRate == 1, 'fa-arrow-down': diffExchangeRate < 1 }"></i>
                </small>
                {{ exchangeRate | pmlFormatCurrencyById(tenant.currency_id) }}
            </p>
        </td>
        <td class="t_center"><label class="label" :class="getStatusLabel(item.status)">{{ $t(item.status) }}</label></td>
        <td class="t_right">
            {{ item.total_products + item.total_discounts + item.total_taxes | pmlFormatCurrencyById(tenant.currency_id) }}
            <small class="show" v-if="tenant.currency_id !== item.currency_id">
                ({{ (item.total_products + item.total_discounts + item.total_taxes) * item.exchange_rate | pmlFormatCurrencyById(item.currency_id) }})
            </small>
        </td>
        <td class="t_center">
            <span class="btn btn-info btn-xs" v-if="item.auto">auto</span>
            <a :href="`/my-quotation/${item.code}`" target="_blank" class="btn btn-primary btn-xs" v-pml-tooltip="$t('show')"><i class="fa-fw md md-visibility"></i></a>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment'
    import { mapGetters } from 'vuex'
    import { quotationStatus } from 'utils/helpers/label-colorify'
    import { findCurrency } from 'utils/helpers/find-store'
    import { round } from 'lodash'

    export default {
        name: 'QuotationItem',
        props: [ 'item' ],
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            }),
            exchangeRate () {
                return round(1 / this.item.exchange_rate, 2).toFixed(2)
            },
            currentExchangeRate () {
                return round(1 / this.getCurrency(this.item.currency_id).pivot.exchange_rate, 2).toFixed(2)
            },
            diffExchangeRate () {
                return (this.item.exchange_rate / this.getCurrency(this.item.currency_id).pivot.exchange_rate).toFixed(2)
            }
        },
        methods: {
            getCurrency: (id) => findCurrency(id),
            getStatusLabel: (status) => quotationStatus(status),
            getStatusLabelDeal (status) {
                if (status === 'sold') return 'label-success'
                if (status === 'lost') return 'label-danger'

                return 'label-default'
            },
            getExchangeClass () {
                if (this.diffExchangeRate === '1.00')
                    return 'text-primary'

                return this.diffExchangeRate > 1 ? 'text-success' : 'text-danger'
            },
            isExpired () {
                return (this.item.status === 'new' || this.item.status === 'sent') &&
                    (this.item.due_date_at < moment().format('YYYY-MM-DD'))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/quotations/components/Item.vue